// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"

// Enable Active Storage direct uploads. This wires up the client that streams
// files straight to S3 (via a presigned URL) when a `direct_upload: true` file
// field's form is submitted, dispatching the direct-upload:* progress events
// the cover-upload controller listens for.
ActiveStorage.start()
import { initializeFormHandlers } from "./utils/formHandler"

// Initialize form handlers when the DOM is loaded AND after Turbo navigations.
// The sign-in / sign-up forms are injected into a <turbo-frame> after initial
// load, so a one-time DOMContentLoaded pass would miss them, leaving the login
// form to submit natively instead of via the JSON/AJAX path that surfaces real
// error messages. setupFormValidation guards against double-binding.
document.addEventListener('DOMContentLoaded', initializeFormHandlers);
document.addEventListener('turbo:load', initializeFormHandlers);
document.addEventListener('turbo:frame-load', initializeFormHandlers);
import { registerServiceWorker } from "./initializers"

// NOTE: Alpine.js was removed. The production CSP has no 'unsafe-eval', which
// Alpine requires to evaluate x-data/x-show expressions, so it was fully broken
// (leaving x-show panels stuck visible). Those few interactions were moved to
// CSP-safe Stimulus controllers (menu, disclosure, lightbox).

// Register service worker
registerServiceWorker()

